import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { downloadBlob } from '../../../utils/downloadBlob.ts';
import { generateTdcxReport } from './generateTdcxReport.ts';

type SaveTcdxFileArgs = {
  reportJSON: ReportJSON;
  orderID: string;
  zipName: string;
  formType: FormType;
  pdfs: { blob: Blob; name: string }[];
  includeAnnotations: boolean;
};

export const saveTdcxFile = async ({
  reportJSON,
  orderID,
  zipName,
  formType,
  pdfs,
  includeAnnotations,
}: SaveTcdxFileArgs) => {
  const tdcx = await generateTdcxReport({
    reportJSON,
    orderID,
    formType,
    pdfs,
    includeAnnotations,
  });

  const blob = new Blob([tdcx], { type: 'application/octet-stream' });
  downloadBlob(blob, `${zipName}.tdcx`);
};
